import { RightOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'

interface IProps {
  title?: string
  children?: React.ReactNode
  right?: React.ReactNode
  link?: string
  padding?: string
  arrowSize?: number
  onClick?: () => void
}

function Cell(props: IProps) {
  const { title, children, link, arrowSize = 20, padding = '24px 32px', right, onClick } = props
  const navigate = useNavigate()

  function handleClick() {
    if (link) {
      navigate(link)
      return
    }

    onClick && onClick()
  }

  const style = {
    padding,
  }

  return (
    <div style={ style }
      className={ styles["cell-box"] }
      onClick={ handleClick } >
      <div className={ styles["cell-title-wrap"] }>
        {
          !!title &&
          <div className={ styles["cell-title"] }>
            { title }
          </div>
        }
        {
          !!children && children
        }
      </div>
      {
        right !== undefined && right
      }
      {
        right === undefined && <RightOutline fontSize={ arrowSize } />
      }
    </div>
  )
}

export default Cell
